module.exports = __webpack_public_path__ + "media/application/images/checkmark-337e10157243bb3a4cd898a5df88702b.svg";